import React from 'react';
import { Attention, GroupedElements, IconButton } from '@axiom/ui';

import { DrawerView } from '../../enums/drawer-view';

export type DrawerViewCtaProps = {
  name: string;
  arrivalCount: number;
  disabled: boolean;
  drawerView: DrawerView;
  hasNewCandidates: boolean;
  hasUnseenCandidates: boolean;
  setDrawerView: (drawerView: DrawerView) => void;
};

export const SparkCandidateDrawerButtons = ({
  name,
  arrivalCount,
  disabled,
  drawerView,
  hasNewCandidates,
  hasUnseenCandidates,
  setDrawerView,
}: DrawerViewCtaProps) => {
  const isLive = (view: DrawerView) =>
    drawerView === view || (!disabled && drawerView === DrawerView.CLOSED);

  const toggle = (view: DrawerView) => () => {
    setDrawerView(drawerView === view ? DrawerView.CLOSED : view);
  };

  const arrivalTrigger = hasNewCandidates && arrivalCount;

  return (
    <Attention
      highlighted={hasUnseenCandidates}
      name={name}
      trigger={arrivalTrigger}
    >
      <GroupedElements
        direction="vertical"
        divider
        name="DRAWER_VIEW_TOGGLES"
        outlined
        shadow
        shape="pill"
      >
        <IconButton
          disabled={!isLive(DrawerView.PARTIAL)}
          icon={`arrow-${drawerView === DrawerView.PARTIAL ? 'right' : 'left'}`}
          name="TOGGLE_PARTIAL_MATCH_GRID"
          onClick={toggle(DrawerView.PARTIAL)}
          pattern="secondary"
          variation="outline"
        />
        <IconButton
          disabled={!isLive(DrawerView.FULL)}
          icon={`double-chevron-${drawerView === DrawerView.FULL ? 'right' : 'left'}`}
          name="TOGGLE_FULL_MATCH_GRID"
          onClick={toggle(DrawerView.FULL)}
          pattern="secondary"
          variation="outline"
        />
      </GroupedElements>
    </Attention>
  );
};
